/**
 * Limites appliquées à tout classeur .xlsx lu depuis un fichier non fiable (import utilisateur).
 * Dépassement = refus du fichier entier, avec un message lisible.
 */
export const XLSX_LIMITS = {
  /** Taille maximale du fichier .xlsx (octets, archive comprimée). */
  maxFileBytes: 5 * 1024 * 1024,
  /** Nombre maximal d’entrées dans l’archive. */
  maxEntries: 100,
  /** Taille décompressée maximale d’une entrée (octets). */
  maxEntryBytes: 25 * 1024 * 1024,
  /** Taille décompressée maximale cumulée (octets). */
  maxTotalBytes: 40 * 1024 * 1024,
  /** Taux de compression maximal toléré pour une entrée de plus de 1 Mio. */
  maxCompressionRatio: 150,
  /** Nombre maximal de feuilles (visibles ou masquées). */
  maxSheets: 30,
  /** Nombre maximal de lignes par feuille (index de ligne le plus grand). */
  maxRows: 10_000,
  /** Nombre maximal de colonnes par feuille (index de colonne le plus grand). */
  maxCols: 200,
  /** Nombre maximal de cellules renseignées, toutes feuilles confondues. */
  maxCells: 300_000,
  /** Nombre maximal de chaînes partagées. */
  maxSharedStrings: 200_000,
  /** Longueur maximale d’un texte de cellule (limite Excel : 32 767 caractères). */
  maxCellChars: 32_767,
  /** Profondeur maximale d’imbrication XML. */
  maxXmlDepth: 64,
} as const;

/** Erreur de lecture d’un classeur : le message est destiné à l’utilisateur. */
export class XlsxImportError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'XlsxImportError';
  }
}
